import React, { useEffect, createElement } from 'react';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { AboutSection } from './components/AboutSection';
import { ServicesSection } from './components/ServicesSection';
import { ContactSection } from './components/ContactSection';
import { LanguageProvider, useLanguage } from './context/LanguageContext';
import { translations } from './utils/translations';
function AppContent() {
  const {
    language
  } = useLanguage();
  const t = translations[language];
  useEffect(() => {
    // Set browser tab title
    document.title = 'Crossroads Consulting Lda';
    // Set favicon dynamically
    let link = document.querySelector("link[rel~='icon']") as HTMLLinkElement;
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.head.appendChild(link);
    }
    link.href = 'https://cdn.magicpatterns.com/uploads/5rM3zo3htVqrwWX2CQZ1op/logo.png';
    link.type = 'image/png';
    // Set social sharing (Open Graph + Twitter) title so link previews
    // show just the company name.
    const shareTitle = 'Crossroads Consulting Lda';
    const setMetaTag = (attr: 'property' | 'name', key: string, value: string) => {
      let tag = document.querySelector(`meta[${attr}="${key}"]`) as HTMLMetaElement | null;
      if (!tag) {
        tag = document.createElement('meta');
        tag.setAttribute(attr, key);
        document.head.appendChild(tag);
      }
      tag.setAttribute('content', value);
    };
    // Open Graph (Facebook, LinkedIn, WhatsApp, etc.)
    setMetaTag('property', 'og:title', shareTitle);
    setMetaTag('property', 'og:type', 'website');
    // Twitter Card
    setMetaTag('name', 'twitter:title', shareTitle);
  }, []);
  return <div className="w-full min-h-screen" data-id="element-0">
      <Header data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <AboutSection data-id="element-4" />
        <ServicesSection data-id="element-5" />
        <ContactSection data-id="element-6" />
      </main>
      <footer className="bg-gray-900 text-white py-8 px-4" data-id="element-7">
        <div className="max-w-7xl mx-auto text-center" data-id="element-8">
          <p className="text-gray-400" data-id="element-9">{t.footer.rights}</p>
        </div>
      </footer>
    </div>;
}
export function App() {
  return <LanguageProvider data-id="element-10">
      <AppContent data-id="element-11" />
    </LanguageProvider>;
}